import {css} from 'lit'; export default css`:host{z-index:61}`;
    